import {Component} from "react";

export class SellToWebTableColumnDrCrComponent extends Component {
} 